var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "members-day-page" },
    [
      _c(
        "div",
        { staticClass: "toolbar-container" },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                staticClass: "search-input",
                attrs: { placeholder: "请输入名称", clearable: "" },
                model: {
                  value: _vm.searchName,
                  callback: function ($$v) {
                    _vm.searchName = $$v
                  },
                  expression: "searchName",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("添加会员日活动")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { staticClass: "data-table", attrs: { data: _vm.list, border: "" } },
        [
          _c("el-table-column", {
            attrs: { label: "编号", prop: "id", width: "80", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题", prop: "title", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "备注", prop: "remark", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动时间", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "date-range" }, [
                      _c("div", [_vm._v(_vm._s(scope.row.startTime))]),
                      _vm._v(" "),
                      _c("div", [_vm._v("—" + _vm._s(scope.row.endTime))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "启用", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePreview(scope.row)
                          },
                        },
                      },
                      [_vm._v("预览")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "pagination-container",
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "footer-actions" }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            direction: "rtl",
            size: "38%",
            "before-close": _vm.handleDrawerClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawer-content" },
            [
              _c(
                "el-form",
                {
                  ref: "membersDayForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.formRules,
                    "label-width": "80px",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "大标题", prop: "mainTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.mainTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "mainTitle", $$v)
                          },
                          expression: "formData.mainTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "小标题", prop: "subTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.subTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "subTitle", $$v)
                          },
                          expression: "formData.subTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "remark", $$v)
                          },
                          expression: "formData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "活动开始背景图" } }, [
                    _c("div", { staticClass: "image-upload-vertical" }, [
                      _c("div", { staticClass: "image-upload-item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "image-upload-box",
                            on: {
                              click: function ($event) {
                                return _vm.uploadImage("startBg1")
                              },
                            },
                          },
                          [
                            !_vm.formData.startBg1
                              ? _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                })
                              : _c("img", {
                                  attrs: {
                                    src: _vm.getImageUrl(_vm.formData.startBg1),
                                    alt: "背景图1",
                                  },
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("背景图1")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-upload-item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "image-upload-box",
                            on: {
                              click: function ($event) {
                                return _vm.uploadImage("startBg2")
                              },
                            },
                          },
                          [
                            !_vm.formData.startBg2
                              ? _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                })
                              : _c("img", {
                                  attrs: {
                                    src: _vm.getImageUrl(_vm.formData.startBg2),
                                    alt: "背景图2",
                                  },
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("背景图2")]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "活动未开始背景图" } }, [
                    _c("div", { staticClass: "image-upload-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "image-upload-box",
                          on: {
                            click: function ($event) {
                              return _vm.uploadImage("notStartBg")
                            },
                          },
                        },
                        [
                          !_vm.formData.notStartBg
                            ? _c("i", {
                                staticClass: "el-icon-picture-outline",
                              })
                            : _c("img", {
                                attrs: {
                                  src: _vm.getImageUrl(_vm.formData.notStartBg),
                                  alt: "未开始背景图",
                                },
                              }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "未开始背景图时间" } }, [
                    _c(
                      "div",
                      { staticClass: "date-range-inputs" },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "请选择",
                            format: "yyyy-MM-dd HH:mm:ss",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.formData.notStartTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "notStartTime", $$v)
                            },
                            expression: "formData.notStartTime",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "date-separator" }, [
                          _vm._v("至"),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "请选择",
                            format: "yyyy-MM-dd HH:mm:ss",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.formData.notStartEndTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "notStartEndTime", $$v)
                            },
                            expression: "formData.notStartEndTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "enabled", $$v)
                            },
                            expression: "formData.enabled",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "form-item-header" },
                      [
                        _c("span", { staticClass: "form-label" }, [
                          _vm._v("权益模块"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: { click: _vm.addRightsModule },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dynamic-section" },
                      _vm._l(
                        _vm.formData.rightsModules,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "dynamic-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "dynamic-row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "image-upload-item-small" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-upload-box-small",
                                          on: {
                                            click: function ($event) {
                                              return _vm.uploadRightsImage(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          !item.image
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline",
                                              })
                                            : _c("img", {
                                                attrs: {
                                                  src: _vm.getImageUrl(
                                                    item.image
                                                  ),
                                                  alt: "权益图片",
                                                },
                                              }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c("label", [_vm._v("排序")]),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: { placeholder: "1" },
                                        model: {
                                          value: item.sort,
                                          callback: function ($$v) {
                                            _vm.$set(item, "sort", $$v)
                                          },
                                          expression: "item.sort",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "form-tip" }, [
                                        _vm._v("(权益排序,排序不可重复)"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c("label", [_vm._v("标题:")]),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        model: {
                                          value: item.title,
                                          callback: function ($$v) {
                                            _vm.$set(item, "title", $$v)
                                          },
                                          expression: "item.title",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "form-tip" }, [
                                        _vm._v("(权益标题)"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    staticClass: "remove-btn",
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeRightsModule(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "积分抽奖图" } }, [
                    _c("div", { staticClass: "image-upload-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "image-upload-box",
                          on: {
                            click: function ($event) {
                              return _vm.uploadImage("pointsLotteryImage")
                            },
                          },
                        },
                        [
                          !_vm.formData.pointsLotteryImage
                            ? _c("i", {
                                staticClass: "el-icon-picture-outline",
                              })
                            : _c("img", {
                                attrs: {
                                  src: _vm.getImageUrl(
                                    _vm.formData.pointsLotteryImage
                                  ),
                                  alt: "积分抽奖图",
                                },
                              }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "积分权益标题",
                        prop: "pointsRightsTitle",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.pointsRightsTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "pointsRightsTitle", $$v)
                          },
                          expression: "formData.pointsRightsTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "积分抽奖ID", prop: "pointsLotteryId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.pointsLotteryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "pointsLotteryId", $$v)
                          },
                          expression: "formData.pointsLotteryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "抽奖类型" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.lotteryType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "lotteryType", $$v)
                            },
                            expression: "formData.lotteryType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "community" } }, [
                            _vm._v("社区"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "order" } }, [
                            _vm._v("点餐"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "模版排序" } }, [
                    _c("div", { staticClass: "template-sort-list" }, [
                      _c(
                        "div",
                        { staticClass: "sort-item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "1" },
                            model: {
                              value: _vm.formData.templateSorts.doublePoints,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.templateSorts,
                                  "doublePoints",
                                  $$v
                                )
                              },
                              expression: "formData.templateSorts.doublePoints",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("双积分模版排序 (数字越小越前)")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sort-item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "2" },
                            model: {
                              value: _vm.formData.templateSorts.flashSale,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.templateSorts,
                                  "flashSale",
                                  $$v
                                )
                              },
                              expression: "formData.templateSorts.flashSale",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("秒杀模版排序 (数字越小越前)")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sort-item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "3" },
                            model: {
                              value: _vm.formData.templateSorts.coupon,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.templateSorts,
                                  "coupon",
                                  $$v
                                )
                              },
                              expression: "formData.templateSorts.coupon",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("领券模版排序 (数字越小越前)")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sort-item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "4" },
                            model: {
                              value: _vm.formData.templateSorts.lottery,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.templateSorts,
                                  "lottery",
                                  $$v
                                )
                              },
                              expression: "formData.templateSorts.lottery",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("抽奖模版排序 (数字越小越前)")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sort-item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "5" },
                            model: {
                              value: _vm.formData.templateSorts.exchange,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.templateSorts,
                                  "exchange",
                                  $$v
                                )
                              },
                              expression: "formData.templateSorts.exchange",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("兑换模版排序 (数字越小越前)")]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "秒杀权益标题", prop: "flashSaleTitle" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.flashSaleTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "flashSaleTitle", $$v)
                          },
                          expression: "formData.flashSaleTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "form-item-header" },
                      [
                        _c("span", { staticClass: "form-label" }, [
                          _vm._v("会员日秒杀"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: { click: _vm.addFlashSale },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dynamic-section" },
                      _vm._l(_vm.formData.flashSales, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "dynamic-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "dynamic-row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-row" },
                                  [
                                    _c("label", [_vm._v("秒杀ID")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入" },
                                      model: {
                                        value: item.id,
                                        callback: function ($$v) {
                                          _vm.$set(item, "id", $$v)
                                        },
                                        expression: "item.id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-row" },
                                  [
                                    _c("label", [_vm._v("排序")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { placeholder: "1" },
                                      model: {
                                        value: item.sort,
                                        callback: function ($$v) {
                                          _vm.$set(item, "sort", $$v)
                                        },
                                        expression: "item.sort",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "form-tip" }, [
                                      _vm._v("(数字越小越前)"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-button", {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFlashSale(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "积分兑换权益",
                        prop: "pointsRedemption",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.pointsRedemption,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "pointsRedemption", $$v)
                          },
                          expression: "formData.pointsRedemption",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "form-item-header" },
                      [
                        _c("span", { staticClass: "form-label" }, [
                          _vm._v("会员积分兑换"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: { click: _vm.addPointsExchange },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dynamic-section" },
                      _vm._l(
                        _vm.formData.pointsExchanges,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "dynamic-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "dynamic-row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c("label", [_vm._v("兑换ID")]),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        model: {
                                          value: item.id,
                                          callback: function ($$v) {
                                            _vm.$set(item, "id", $$v)
                                          },
                                          expression: "item.id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c("label", [_vm._v("排序")]),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: { placeholder: "1" },
                                        model: {
                                          value: item.sort,
                                          callback: function ($$v) {
                                            _vm.$set(item, "sort", $$v)
                                          },
                                          expression: "item.sort",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "form-tip" }, [
                                        _vm._v("(数字越小越靠前)"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    staticClass: "remove-btn",
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removePointsExchange(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "页面分享标题", prop: "shareTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formData.shareTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "shareTitle", $$v)
                          },
                          expression: "formData.shareTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动开始时间", prop: "activityTime" } },
                    [
                      _c(
                        "div",
                        { staticClass: "date-range-inputs" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "开始时间",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.handleTimeChange },
                            model: {
                              value: _vm.formData.startTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "startTime", $$v)
                              },
                              expression: "formData.startTime",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "date-separator" }, [
                            _vm._v("至"),
                          ]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "结束时间",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.handleTimeChange },
                            model: {
                              value: _vm.formData.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "endTime", $$v)
                              },
                              expression: "formData.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.drawerVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览会员日活动",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }